export const getBackupList = (payload?: any) => ({
    type: "@saga/GET_BACKUP_LIST",
    payload
});

